{
	"name": "almacen-react",
	"private": true,
	"version": "1.2.1",
	"type": "module",
	"scripts": {
		"dev": "vite",
		"build": "tsc -b && vite build",
		"lint": "tsc --noEmit && eslint",
		"preview": "vite preview",
		"_Docker": "",
		"docker": "npm run dockerBuild && npm run dockerPushVersion && npm run dockerPushLatest",
		"dockerBuild": "docker build -t $npm_package_config_image_name:$npm_package_version$npm_package_config_tag_suffix -t $npm_package_config_image_name:latest$npm_package_config_tag_suffix .",
		"dockerPushVersion": "docker push $npm_package_config_image_name:$npm_package_version$npm_package_config_tag_suffix",
		"dockerPushLatest": "docker push $npm_package_config_image_name:latest$npm_package_config_tag_suffix"
	},
	"config": {
		"image_name": "code.wundersolutions.es/piher/almacen-panel",
		"tag_suffix": "-rial"
	},
	"dependencies": {
		"@dnd-kit/core": "^6.3.1",
		"@dnd-kit/sortable": "^10.0.0",
		"@dnd-kit/utilities": "^3.2.2",
		"@fortawesome/fontawesome-free": "^7.2.0",
		"@tanstack/react-form": "^1.28.6",
		"@tanstack/react-query": "^5.96.2",
		"@tanstack/react-table": "^8.21.3",
		"datatables.net-dt": "^2.3.7",
		"datatables.net-react": "^1.0.1",
		"react": "^19.2.4",
		"react-dom": "^19.2.4",
		"react-router": "^7.14.0",
		"react-select": "^5.10.2",
		"react-toastify": "^11.0.5",
		"zod": "^4.3.6"
	},
	"devDependencies": {
		"@eslint/js": "^9",
		"@babel/core": "^7.29.0",
		"@rolldown/plugin-babel": "^0.2.2",
		"@types/babel__core": "^7.20.5",
		"@types/node": "^24.12.2",
		"@types/react": "^19.2.14",
		"@types/react-dom": "^19.2.3",
		"babel-plugin-react-compiler": "^1.0.0",
		"@vitejs/plugin-react": "^6.0.1",
		"eslint": "^9",
		"eslint-plugin-react": "^7.37.5",
		"eslint-plugin-react-hooks": "^7.0.1",
		"eslint-plugin-react-refresh": "^0.5.2",
		"globals": "^17.4.0",
		"sass-embedded": "^1.99.0",
		"typescript": "^5",
		"typescript-eslint": "^8",
		"vite": "^8"
	}
}